"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconColor = void 0;
const getIconColor = ({ isInverted, isDisabled, theme, }) => {
    if (isInverted && isDisabled) {
        return theme.colorInvertedDisabled;
    }
    if (isInverted) {
        return theme.colorInverted;
    }
    if (isDisabled) {
        return theme.colorDisabled;
    }
    return theme.color;
};
exports.getIconColor = getIconColor;
